export default "__VITE_ASSET__DRzl6pGf__"